@use "../../../styles/Colors.scss" as Colors;
@use "../../../styles/Constants.scss" as Constants;

.selectToLoad {
	color: Colors.$col-greyDark;
	background: Colors.$col-greyBackground;
	padding: Constants.$val-spacing-m;
	display: flex;
	align-items: center;
	font-style: normal;

	& b {
		margin: 0 3px;
	}
}

.noRowsFound {
	color: Colors.$col-greyDark;
	background: Colors.$col-greyBackground;
	padding: Constants.$val-spacing-m;
	display: flex;
	align-items: center;
	font-style: normal;
}

.iconWarning {
	margin-right: Constants.$val-spacing-xs;
	font-size: 16px;
	color: Colors.$col-orange;
}

.iconInfo {
	margin-right: Constants.$val-spacing-xs;
	font-size: 16px;
	color: Colors.$col-design-blue500;
}

.loadingTableContainer {
	display: inline-block;
	position: sticky;
	left: 50%;
	background-color: Colors.$col-white;
	padding: Constants.$val-spacing-m;
	top: 50%;
	text-align: center;
	transform: translateX(-50%);
	color: Colors.$col-design-grey10;
	font-style: italic;
	height: fit-content;
}

.loadingTableContent {
	color: var(--col-grey-700);
	background: var(--col-blue-100);
	padding: Constants.$val-spacing-m;
	padding-left: Constants.$val-spacing-l + Constants.$val-spacing-s;
	display: flex;
	align-items: center;
	position: relative;
	font-style: normal;

	& .spinner::after {
		content: "";
		position: absolute;
		top: 0;
		left: 10px;
		// right: 0;
		bottom: 0;
		margin: auto;
		border: 2px solid transparent;
		border-radius: 50%;
		animation: spin 1s ease infinite;
		border-top-color: var(--col-grey-700);
		border-right-color: var(--col-grey-700);
		border-bottom-color: var(--col-grey-700);
		height: 14px;
		width: 14px;
	}
}

@keyframes spin {
	from {
		transform: rotate(0turn);
	}

	to {
		transform: rotate(1turn);
	}
}
